import { createContext, useContext } from 'react';

import type { useComboboxState } from './useComboboxState';

type ComboboxContextType = ReturnType<typeof useComboboxState>;

export const ComboboxContext = createContext<ComboboxContextType>({
  isItemDisabled: false,
  isFocused: false,
  isOpen: false,
  itemHeight: 38,
  size: 'medium',
});

export const useComboboxContext = () => {
  return useContext(ComboboxContext);
};
